export default "__VITE_ASSET__8d351a9e__"